import { render } from "./AgentePresenciaJunta.vue?vue&type=template&id=4097c84d&scoped=true"
import script from "./AgentePresenciaJunta.vue?vue&type=script&lang=ts"
export * from "./AgentePresenciaJunta.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4097c84d"

export default script